import React, { createContext, useContext, useState } from 'react';
import ReactDOM from 'react-dom';
import './Toast.scss';

interface IToastContext {
    show: (message: string, type: EToastType, position: EToastPosition) => void;
}

export enum EToastType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning'
}

export enum EToastPosition {
    TOP = 'top',
    BOTTOM = 'bottom'
}

const defaultToastContextValue: IToastContext = {
    show: (message: string, type: EToastType, position: EToastPosition) => {},
  };

const ToastContext = createContext(defaultToastContextValue);

export const ToastProvider = ({ children }) => {
    let visibleTimeout = null
    let exitingTimeout = null

    const [isExiting, setIsExiting] = useState(false);
    const [{ isVisible, message, position, type}, setToast] = useState<{
        isVisible: boolean;
        message: string;
        type: EToastType;
        position: EToastPosition;
    }>({
        isVisible: false,
        message: '',
        type: EToastType.INFO,
        position: EToastPosition.TOP
    });

    const show = (message: string, type: EToastType, position: EToastPosition) => {
        setIsExiting(false)
        setToast({ isVisible: true, message, type, position });
        visibleTimeout = setTimeout(() => {
            setIsExiting(true)
            exitingTimeout = setTimeout(() => {
                setToast((prev) => ({ ...prev, isVisible: false }))
                clearTimeout(visibleTimeout);
                clearTimeout(exitingTimeout);
                visibleTimeout = null
                exitingTimeout = null
            }, 500);
        }, 3000);
    };

    return (
        <ToastContext.Provider value={{ show }}>
        {children}
        {isVisible && ReactDOM.createPortal(
            <div className="toast-container" data-position={position}>
                <div
                    className={`toast ${isExiting ? 'toast-exit' : 'toast-enter'}`}
                    data-type={type}
                    data-position={position}
                >
                    {message}
                </div>
            </div>,
            document.getElementById('app')
        )}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};